<add-video-comment [ngClass]="styles.addComment" [videoId]="video.id">
</add-video-comment>

<div vbUiRadioBtnGroup [attr.aria-label]="'Media_Videos_Comments_SortCriteria' | translate" [ngClass]="styles.toggleBtn">
	<button type="button" [(ngModel)]="isAscending" [vbUiRadioBtn]="false">
		{{ 'Media_Videos_Comments_SortByDate_New' | translate }}
	</button>
	<button type="button" [(ngModel)]="isAscending" [vbUiRadioBtn]="true">
		{{ 'Media_Videos_Comments_SortByDate_Old' | translate }}
	</button>
</div>

<section>
	<video-comment-list [comments]="video.comments" [isAscending]="isAscending">
	</video-comment-list>
</section>
